// Minimal hash-based router (no external dependency)
// Exposes: getPath(), getQuery(), getParams(), push(path), onChange(cb)

function parseHash() {
  const raw = window.location.hash || '#/'
  const s = raw.startsWith('#') ? raw.slice(1) : raw
  const [path, q = ''] = s.split('?')
  const query = Object.fromEntries(new URLSearchParams(q))
  return { path: path || '/', query }
}

// Extract params from path patterns like /games/poker/:mode
function extractParams(path, pattern) {
  const pathParts = path.split('/').filter(Boolean)
  const patternParts = pattern.split('/').filter(Boolean)
  const params = {}

  for (let i = 0; i < patternParts.length; i++) {
    const part = patternParts[i]
    if (part.startsWith(':')) {
      const key = part.slice(1)
      params[key] = pathParts[i] || null
    }
  }
  return params
}

const listeners = new Set()

function notify() {
  const state = parseHash()
  listeners.forEach(cb => {
    try { cb(state) } catch (_) {}
  })
}

export const router = {
  getPath() { return parseHash().path },
  getQuery() { return parseHash().query },
  getParams(pattern) {
    return extractParams(parseHash().path, pattern)
  },
  push(path) {
    if (!path.startsWith('#')) path = '#' + path
    if (window.location.hash === path) {
      // force notify for same-hash navigation
      notify()
    } else {
      window.location.hash = path
    }
  },
  onChange(cb) {
    listeners.add(cb)
    return () => listeners.delete(cb)
  }
}

window.addEventListener('hashchange', notify)
// Notify once on load
setTimeout(notify, 0)

